import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ProgramTemplatePickerDialogComponent } from './program-template-picker-dialog.component';
import { ProgramTemplatePreviewDialogComponent } from './program-template-preview/program-template-preview-dialog.component';

@NgModule({
  declarations: [
    ProgramTemplatePickerDialogComponent,
    ProgramTemplatePreviewDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [ProgramTemplatePickerDialogComponent]
})
export class ProgramTemplatePickerModule {}
